"use strict";
import { useQuery } from "@tanstack/react-query";
import { useCallback } from "react";
import ERC20_ABI from "uniswap/src/abis/erc20.json";
import { getContract } from "utilities/src/contracts/getContract";
import { logger } from "utilities/src/logger/logger";
import { ReactQueryCacheKey } from "utilities/src/reactQuery/cache";
export function useCreateTransferTransaction(transferInfo) {
  const transactionFetcher = useCallback(() => {
    return getTransferTransaction(transferInfo);
  }, [transferInfo]);
  return useQuery({
    queryFn: transactionFetcher,
    queryKey: [
      ReactQueryCacheKey.CreateTransferTransaction,
      transferInfo?.account,
      transferInfo?.chainId,
      transferInfo?.currencyAmount?.toExact(),
      transferInfo?.currencyAmount?.currency,
      transferInfo?.toAddress
    ]
  }).data;
}
async function getTransferTransaction(transferInfo) {
  if (!transferInfo) {
    return null;
  }
  const { provider, account, chainId, currencyAmount, toAddress } = transferInfo;
  if (!provider || !account || !chainId || !currencyAmount || !toAddress) {
    return null;
  }
  const currency = currencyAmount.currency;
  const params = {
    provider,
    account,
    chainId,
    toAddress,
    tokenAddress: currency.isNative ? "" : currency.address,
    amountInWei: currencyAmount.quotient.toString()
  };
  return currency.isNative ? getNativeTransferRequest(params) : getTokenTransferRequest(params);
}
function getNativeTransferRequest(params) {
  const { account, toAddress, amountInWei, chainId } = params;
  return {
    from: account,
    to: toAddress,
    value: amountInWei,
    chainId
  };
}
async function getTokenTransferRequest(transferParams) {
  const { provider, account, chainId, toAddress, tokenAddress, amountInWei } = transferParams;
  const tokenContract = getContract({ address: tokenAddress, ABI: ERC20_ABI, provider, account });
  try {
    const populatedTransaction = await tokenContract.populateTransaction.transfer(toAddress, amountInWei, {
      from: account
    });
    return { ...populatedTransaction, chainId };
  } catch (error) {
    logger.error(error, {
      tags: {
        file: "transfer",
        function: "getTokenTransferRequest"
      },
      extra: { transferParams }
    });
  }
  return null;
}
